import React from 'react'
import PropTypes from 'prop-types'
import {Dropdown, Button} from '@/components/atoms'
import NonInteractiveDropdownTrigger from './NonInteractiveDropdownTrigger'
import {Font} from 'pepsico-ds'
import {Constants} from '@/utils/constants/commonConstants'
import styles from '../RewardSetup.module.scss'

export default function SegmentsGroupRow({
  group,
  index,
  onOpen,
  onDelete,
  groupPlaceholder,
}) {
  return (
    <div
      id={`segments-group-row-${group.id}`}
      data-testid={`segments-group-row-${group.id}`}
      className="flex flex-col gap-2"
    >
      <div className="flex items-center justify-between">
        <Font size="xsmall" data-testid={`segments-group-row-${group.id}-label`}>{`Group ${group.id}`}</Font>
      </div>
      <div className="flex items-end gap-2">
        <NonInteractiveDropdownTrigger
          id={`segments-group-row-${group.id}-dropdown-trigger`}
          testId={`segments-group-row-${group.id}-dropdown-trigger`}
          ariaLabel={`Open segment group ${group.id}`}
          onOpen={() => onOpen(index)}
        >
          <Dropdown
            className={`${styles.rewardSetup__segments_dropdown}`}
            value={group.items}
            label={''}
            isDark={true}
            childList={[]}
            placeholder={groupPlaceholder(group.items)}
            selection="multiple"
            isJsonWrap={false}
          />
        </NonInteractiveDropdownTrigger>
        {index > 0 && (
          <div id={`segments-group-row-${group.id}-delete`} data-testid={`segments-group-row-${group.id}-delete`}>
            <Button
              handleButton={() => onDelete(index)}
              uiSchema={{
                title: Constants.DeleteGroup,
                size: 'small',
                variant: 'text',
                isDark: true,
                className: 'text-sm flex text-auxiliary items-center mt-1 mb-1',
              }}
            />
          </div>
        )}
      </div>
    </div>
  )
}

SegmentsGroupRow.propTypes = {
  group: PropTypes.shape({
    id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
    items: PropTypes.arrayOf(
      PropTypes.shape({
        id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
        name: PropTypes.string,
        label: PropTypes.string,
      })
    ).isRequired,
  }).isRequired,
  index: PropTypes.number.isRequired,
  onOpen: PropTypes.func.isRequired,
  onDelete: PropTypes.func.isRequired,
  groupPlaceholder: PropTypes.func.isRequired,
}

